module.exports = __webpack_public_path__ + "static/img/ex_t4.954cdee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ex_t4.jpg
// module id = kY6P
// module chunks = 1